import { closeTransaction, openTransaction, transactionUpdates } from './engine';
import { spyGetters } from './node';
import { autoTerminalAware, proxify, ObservableNode, isValueSet } from './observable';
import { EMPTY } from './utils';
class ComputableNode extends ObservableNode {
    constructor(computor, initValue, entryUidFunc) {
        super(initValue, undefined, undefined, entryUidFunc);
        this._computor = computor;
        this._initialized = false; // отменяем инициализацию
        this._sources = new Set();
        //this._publishers = []
        //this._touched = false
    }
    $compute() {
        if (this._computing) {
            return this._memoValue;
        }
        this._computing = true;
        let next = undefined;
        // this._publishers.forEach(dep => {
        //     if ((dep.observable as any)._destroyed) {
        //         console.warn('Destroyed dependency detected', dep)
        //         this._destroyed = true
        //     }
        // })
        // if (this._destroyed) {
        //     this._publishers.forEach(dep => {
        //     })
        //     return undefined
        // }
        // this._publishers = []
        //         this._sources.forEach(dep => {
        //             if ((dep as any)._destroyed) {
        //                 // TODO поместить в очередь на удаление
        //                 this._destroyed = true
        //             }
        //         })
        //         if (this._destroyed) {
        //             this._sources.forEach(dep => {
        //                 dep.$unsubscribe(this)
        //             })
        //             this._sources.clear()
        // //            this._destroyed = false
        //             return
        //         }
        const getters = spyGetters(() => {
            next = autoTerminalAware(this._computor);
        });
        this._computing = false;
        // getters.forEach(dep => {
        //     if ((dep as any)._destroyed) {
        //         console.warn('Destroyed dependency detected', dep)
        //         this._destroyed = true
        //     }
        // })
        // if (!this._destroyed) {
        getters.forEach(dep => {
            // автоподписка
            dep.$subscribe(this);
            this._sources.add(dep);
        });
        // }
        if (isValueSet(next)) {
            next = next.$value;
        }
        return next;
    }
    // $touch(subscriber: Subscriber<T>): void {
    //     let value = undefined
    //     if (!this._touched) {
    //         value = this.$compute()
    //         this._touched = true
    //     }
    //     subscriber.$publish(value, undefined, EMPTY)       
    // }
    $publish(next, prev, keys) {
        //        console.log('publish computable', next)
        if (this._destroyed) {
            console.warn('Publishing to destroyed computable');
            return;
        }
        let computed = undefined;
        try {
            computed = this.$compute();
        }
        catch (err) {
            console.error('Compute error', err);
        }
        if (computed && typeof computed.$at === 'function') {
            computed = computed.$value;
        }
        if (this.$isPrimitive && computed === this._memoValue) {
            //            console.log('No change detected', computed, this._memoValue)
            return;
        }
        const t = openTransaction();
        super.$publish(computed, null, EMPTY);
        let count = 0;
        transactionUpdates(t).forEach(upd => {
            // FIXME
            count += upd.node.$subscriptions.length;
        });
        if (count == 0) {
            //            debugger
            this._sources.forEach(dep => {
                dep.$unsubscribe(this);
            });
            this._sources.clear();
            this._initialized = false;
            //            this._destroyed = true
            //            console.log('unsubscribed computable detected [publish]')
        }
        closeTransaction(t);
        // this._updateEntries(computed)
        // // у вычисляемых значений нет родителя/источника, поэтому обновляем поддерево только вниз
        // this.$update(UpdateDirection.DESC, computed, null, EMPTY)    
    }
    $unsubscribe(subscription) {
        super.$unsubscribe(subscription);
        // быстрая проверка на отписку
        if (this._subscriptions.length == 0 && Object.keys(this._entries).length == 0) {
            this._sources.forEach(dep => {
                dep.$unsubscribe(this);
            });
            this._sources.clear();
            this._initialized = false;
            this.$destroy();
            //            this._destroyed = true
            //            console.log('unsubscribed computable detected [unsubscribe]')
        }
    }
    $get() {
        //        console.log('compute')
        return this._initialized ? this._memoValue : this.$compute();
    }
}
//const _computeQue: ComputableNode<any>[] = []
export const computable = (compute, initValue, entryUidFunc) => {
    let c = proxify(null, new ComputableNode(compute, initValue, entryUidFunc));
    // TODO переделать в compute engine?
    // if (_computeQue.length == 0) {
    //     setTimeout(() => {
    //         while(_computeQue.length) {
    //             _computeQue.shift().$publish(null)
    //         }
    //     })    
    // }
    // _computeQue.push(c)
    return c;
};
